var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 745.78 527.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#797a7d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M714.32,204.05c6-121-91-76-91-76C616.31,31,563,53.3,563,53.3,556.31,44,541.31,5,488.66,6.52,442,7.83,416.33,33.94,402.23,60.69c-7.16,13.58-26.79,12.93-33.18-1C323.55-39.7,216.31,15,216.31,15c-66-26-90.59,62.52-90.59,62.52C34.14,86.07,74.31,181,74.31,181c-100-4-45,153-45,153C-77.24,446.89,141,527.43,141,527.43S196.82,418.9,158.58,347C216.6,121.86,396.31,143,396.31,143c261,3,232.86,384.39,232.86,384.39C816,483.82,714.61,365.19,714.61,365.19,784.91,273.33,714.32,204.05,714.32,204.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M629.17,527.43S557.32,447.89,613.32,347l39.58,48.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.24,26.9s41.43-37.15,82.25,0-44.12,68.58-44.12,68.58Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset23);
export default __webpack_public_path__ + "static/media/Asset 23.a5b70eb2.svg";
export { ForwardRef as ReactComponent };